<template>
    <div ref="root" class="relative" @keydown.esc="close">
        <button
            type="button"
            class="flex items-center gap-2 cursor-pointer text-small font-semibold underline-offset-4 hover:underline"
            aria-haspopup="true"
            :aria-expanded="open"
            @click="open = !open"
        >
            Admin
            <svg class="h-3 w-3 transition-transform" :class="open && 'rotate-180'" viewBox="0 0 12 12" aria-hidden="true">
                <path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/>
            </svg>
        </button>

        <div v-if="open" class="absolute left-0 top-full mt-3 z-20 w-56 bg-canvas border border-line-strong py-2 flex flex-col">
            <NuxtLink to="/admin" class="px-4 py-2 text-small font-semibold hover:bg-surface">Manage collections</NuxtLink>
            <NuxtLink to="/collector/pair" class="px-4 py-2 text-small font-semibold hover:bg-surface">Pair error collector</NuxtLink>
            <NuxtLink to="/admin/releases" class="px-4 py-2 text-small font-semibold hover:bg-surface">App releases</NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const open = ref(false)
const root = ref<HTMLElement>()

const close = () => {
    open.value = false
}

// Close on a click anywhere outside the menu, and after navigating
const onDocumentClick = (event: MouseEvent) => {
    if (root.value && !root.value.contains(event.target as Node)) close()
}
watch(open, (isOpen) => {
    if (isOpen) document.addEventListener('click', onDocumentClick)
    else document.removeEventListener('click', onDocumentClick)
})
watch(() => route.fullPath, close)
onBeforeUnmount(() => document.removeEventListener('click', onDocumentClick))
</script>
